import BaseView from "@/components/omniSearch/searchViews/BaseView";

const SearchLoadingView = () => {
  return <BaseView>Searching...</BaseView>;
};

export default SearchLoadingView;
